export interface PredictiveScores {
  forecasting: number;
  dataQuality: number;
  actionability: number;
}

export interface Question {
  id: number;
  question: string;
  options: {
    text: string;
    scores: PredictiveScores;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    question: "How do you currently make business decisions about the future?",
    options: [
      {
        text: "Mostly gut feeling and past experience",
        scores: { forecasting: 3, dataQuality: 2, actionability: 1 },
      },
      {
        text: "Review last year's numbers and hope trends continue",
        scores: { forecasting: 2, dataQuality: 2, actionability: 1 },
      },
      {
        text: "Some basic data analysis with spreadsheets",
        scores: { forecasting: 1, dataQuality: 1, actionability: 2 },
      },
      {
        text: "Advanced analytics and statistical forecasting",
        scores: { forecasting: 0, dataQuality: 1, actionability: 2 },
      },
    ],
  },
  {
    id: 2,
    question: "What's your biggest challenge when trying to predict business outcomes?",
    options: [
      {
        text: "Don't know which patterns in our data actually matter",
        scores: { forecasting: 3, dataQuality: 1, actionability: 1 },
      },
      {
        text: "Data is incomplete, inconsistent, or hard to trust",
        scores: { forecasting: 1, dataQuality: 3, actionability: 1 },
      },
      {
        text: "Have insights but struggle to turn them into action",
        scores: { forecasting: 0, dataQuality: 1, actionability: 3 },
      },
      {
        text: "No clear way to measure if predictions are accurate",
        scores: { forecasting: 2, dataQuality: 1, actionability: 2 },
      },
    ],
  },
  {
    id: 3,
    question: "How often are you surprised by business changes you wish you'd seen coming?",
    options: [
      {
        text: "Constantly - feels like we're always reacting",
        scores: { forecasting: 3, dataQuality: 1, actionability: 2 },
      },
      {
        text: "Often - major changes catch us off guard",
        scores: { forecasting: 2, dataQuality: 1, actionability: 1 },
      },
      {
        text: "Sometimes - we see some trends but miss others",
        scores: { forecasting: 1, dataQuality: 2, actionability: 1 },
      },
      {
        text: "Rarely - we usually see changes developing",
        scores: { forecasting: 0, dataQuality: 1, actionability: 2 },
      },
    ],
  },
  {
    id: 4,
    question: "How clean and organized is your business data?",
    options: [
      {
        text: "Scattered everywhere - different formats, lots of errors",
        scores: { forecasting: 1, dataQuality: 3, actionability: 1 },
      },
      {
        text: "Somewhat organized but has quality issues",
        scores: { forecasting: 1, dataQuality: 2, actionability: 1 },
      },
      {
        text: "Mostly clean but could be more integrated",
        scores: { forecasting: 1, dataQuality: 1, actionability: 2 },
      },
      {
        text: "Well-structured and reliable across the board",
        scores: { forecasting: 1, dataQuality: 0, actionability: 2 },
      },
    ],
  },
  {
    id: 5,
    question: "When you get insights from data, what happens next?",
    options: [
      {
        text: "Insights sit in reports - unclear how to use them",
        scores: { forecasting: 1, dataQuality: 0, actionability: 3 },
      },
      {
        text: "We discuss them but struggle to implement changes",
        scores: { forecasting: 0, dataQuality: 1, actionability: 3 },
      },
      {
        text: "Some insights lead to action, others get lost",
        scores: { forecasting: 1, dataQuality: 1, actionability: 2 },
      },
      {
        text: "Clear processes turn insights into decisions quickly",
        scores: { forecasting: 2, dataQuality: 1, actionability: 0 },
      },
    ],
  },
  {
    id: 6,
    question: "What would make the biggest difference to your business planning?",
    options: [
      {
        text: "Knowing what's likely to happen 3-6 months out",
        scores: { forecasting: 3, dataQuality: 0, actionability: 1 },
      },
      {
        text: "Having data I can actually trust and use",
        scores: { forecasting: 1, dataQuality: 3, actionability: 0 },
      },
      {
        text: "Better tools to turn data into clear next steps",
        scores: { forecasting: 0, dataQuality: 1, actionability: 3 },
      },
      {
        text: "Understanding which metrics actually predict success",
        scores: { forecasting: 2, dataQuality: 1, actionability: 1 },
      },
    ],
  },
  {
    id: 7,
    question: "How do you currently track if your business strategies are working?",
    options: [
      {
        text: "Waiting to see final results - often too late to adjust",
        scores: { forecasting: 2, dataQuality: 1, actionability: 2 },
      },
      {
        text: "Monthly or quarterly reviews with basic metrics",
        scores: { forecasting: 1, dataQuality: 2, actionability: 1 },
      },
      {
        text: "Regular tracking but not predictive - just historical",
        scores: { forecasting: 2, dataQuality: 1, actionability: 1 },
      },
      {
        text: "Real-time dashboards with leading indicators",
        scores: { forecasting: 0, dataQuality: 1, actionability: 2 },
      },
    ],
  },
];
